<template>
    <a href="/basket" class="relative text-gray-600 hover:text-brill-blue">
        <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"/>
        </svg>
        <span
            v-if="count > 0"
            class="absolute -top-2 -right-2 bg-brill-red text-white text-xs font-bold px-2 py-0.5 rounded-full"
        >
            {{ displayCount }}
        </span>
    </a>
</template>

<script>
export default {
    name: 'BasketWidget',

    props: {
        initialCount: {
            type: Number,
            default: 0,
        },
    },

    data() {
        return {
            count: this.initialCount,
        };
    },

    computed: {
        displayCount() {
            return this.count > 99 ? '99+' : this.count;
        },
    },

    mounted() {
        // Listen for basket updates from AddToBasket component
        window.addEventListener('basket-updated', this.handleBasketUpdate);

        // Optionally fetch current count on mount
        this.fetchBasketCount();
    },

    beforeDestroy() {
        window.removeEventListener('basket-updated', this.handleBasketUpdate);
    },

    methods: {
        handleBasketUpdate(event) {
            if (event.detail && typeof event.detail.count === 'number') {
                this.count = event.detail.count;
            }
        },

        async fetchBasketCount() {
            try {
                const response = await fetch('/basket/count');
                const data = await response.json();
                this.count = data.count || 0;
            } catch (err) {
                console.error('Failed to fetch basket count:', err);
            }
        },
    },
};
</script>

<style scoped>
.bg-brill-red {
    background-color: #C41E3A;
}
.text-brill-blue {
    color: #1E4D8C;
}
.hover\:text-brill-blue:hover {
    color: #1E4D8C;
}
</style>
